export const DataSubjectRightsSection = () => (
  <section>
    <h2>9. Data Subject Rights</h2>

    <p>
      Individuals have rights concerning their Personal Data. If you wish to
      exercise your privacy rights under any applicable law, including the EU
      General Data Protection Regulation (GDPR) or the California Consumer
      Privacy Act (CCPA), such as the right to request access to, and
      rectification or erasure of your Personal Data held with Volca, or to
      restrict or object to such Personal Data's processing, or to port such
      Personal Data, or the right to equal services and prices (each to the
      extent available to you under the laws which apply to you) – please
      contact us by e-mail at:{" "}
      <a href="mailto:support@volca.ai">support@volca.ai</a>.
    </p>

    <p>
      Please note that when you ask us to exercise any of your rights under this
      policy or applicable law, we may need to ask you to provide us certain
      credentials to make sure that you are who you claim you are, to avoid
      disclosure to you of personal information related to others and to ask you
      to provide further information to better understand the nature and scope
      of data that you request to access. Such additional data will be then
      retained by us for legal purposes (e.g. as proof of the identity of the
      person submitting the request), in accordance with Section ‎‎4 above.
    </p>

    <p>
      We may redact from the data which we will make available to you, any
      personal data related to others.
    </p>

    <p>
      If you would like to make any requests or queries regarding Personal Data
      that we process on our customer's behalf, please contact the administrator
      of such customer's account directly. For example, if you are our
      customer's customer or prospect, or if you are a user of Volca on behalf
      of our customer, and wish to access, correct, or delete data processed by
      Volca on behalf of our customer, please direct your request to the
      relevant customer (who is the "data controller" of such data – see Section
      ‎‎10 below). Note that if you do contact us, we may share your
      communications with our customer and its account users; and that we may
      also share the contact details of the account administrator with
      individuals who sent us such a request or query relating to this account.
    </p>
  </section>
);
